import {doc, DocumentReference, getDoc, getFirestore, updateDoc} from "@firebase/firestore"
import {FirebaseConverter} from "../../firebase/firebaseConverter"
import {UserData} from "../../models/UserData"
import _ from "lodash";
import {setDoc} from "firebase/firestore";

const converter = new FirebaseConverter<UserData>()


const getDocumentReference = (userId: string): DocumentReference<UserData> => doc(getFirestore(), `users/${userId}`).withConverter(converter)


export const updateUserDataDocument = async (userData: UserData): Promise<void> => {
  const docRef = getDocumentReference(userData.uid)
  return updateDoc(docRef, _(userData).omit(['security_role']).omitBy(_.isUndefined).value())
}

export const createUserDataDocument = async (userData: UserData): Promise<void> => {
  const docRef = getDocumentReference(userData.uid)
  return setDoc(docRef, userData)
}
export const getUserDataDocument = async (userId: string): Promise<UserData> => {
  const docRef = getDocumentReference(userId)
  const document = await getDoc(docRef)
  if (document.exists()) {
    return document.data()
  } else {
    return Promise.reject(`User with id ${userId} does not exist`);
  }
}

